export const clientServiceTypes = [
    {
        label: "Γραφεία Ενοικίασης Αυτοκινήτων",
        value: "1",
        permission: "custom-DclRental"
    },
    {
        label: "Πάρκινγκ - Πλυντήρια Αυτοκινήτων",
        value: "2",
        permission: "custom-DclParking"
    },
    {
        label: "Συνεργεία Αυτοκινήτων",
        value: "3",
        permission: "custom-DclGarage"
    }
]
